import { create } from 'zustand';

interface MasterDemoStore {
  isMasterDemo: boolean;
  setMasterDemoStatus: (status: boolean) => void;
}

export const useMasterDemoStore = create<MasterDemoStore>((set) => ({
  isMasterDemo: false,
  setMasterDemoStatus: (status: boolean) => set({ isMasterDemo: status }),
}));
